import { MenuItemProps, ResolvedBasicMenuItem, ResolvedSubMenuItem } from '@wix/thunderbolt-becky-types'

export const resolveMenuItemsRecursively = (
	item: ResolvedBasicMenuItem | ResolvedSubMenuItem,
	isMobileView: boolean,
	withId: boolean,
	allowSlotItemWithSubItems: boolean
): MenuItemProps => {
	const id = withId ? { id: item.id } : {}
	const label = item.label
	const subItems = item.items
	// @ts-ignore
	const link = item.link?.resolvedLink ?? {}
	const slot = isResolvedBasicMenuItem(item) ? { slot: item.slot } : {}

	const items = subItems
		? subItems
				.filter((subItem) => shouldShowItem(subItem, isMobileView, allowSlotItemWithSubItems))
				.map((subItem) => resolveMenuItemsRecursively(subItem, isMobileView, withId, allowSlotItemWithSubItems))
		: []

	const filteredItems = items.length > 0 ? { items } : {}

	const result: MenuItemProps & { slot?: string } = {
		label,
		link,
		...filteredItems,
		...slot,
		...id,
	}

	return result
}

const isResolvedBasicMenuItem = (item: ResolvedBasicMenuItem | ResolvedSubMenuItem): item is ResolvedBasicMenuItem =>
	'slot' in item

const shouldShowItem = (
	item: ResolvedBasicMenuItem | ResolvedSubMenuItem,
	isMobileView: boolean,
	allowSlotItemWithSubItems: boolean
) => {
	const isVisible = isMobileView ? item.isVisibleMobile : item.isVisible

	if (!isVisible) {
		return false
	}

	const slotId = isResolvedBasicMenuItem(item) ? item.slot : undefined
	const noSlot = !slotId

	if (noSlot) {
		return true
	}

	if (allowSlotItemWithSubItems) {
		const subItems = item.items
		const subItemsCount = subItems?.length ?? 0
		const isSlotItemWithSubItems = subItemsCount > 0

		return isSlotItemWithSubItems
	}

	return false
}
